import { Icon as PhosphorIcon } from '@phosphor-icons/react'
import { useTranslation } from 'react-i18next'

import { Badge } from '@/components/ui/badge'
import { Icon } from '@/components/ui/icon'
import { Skeleton } from '@/components/ui/skeleton'

import * as S from './details-card.styled'

interface DetailsCardProps {
  icon: PhosphorIcon
  title: string
  value: string | number
  isFree?: boolean
  loading?: boolean
  variant?: 'default' | 'compact'
}

export const DetailsCard = ({
  icon,
  isFree = false,
  loading = false,
  title,
  value,
  variant = 'default',
}: DetailsCardProps) => {
  const { t } = useTranslation(['visitor-parking'])

  return (
    <S.DetailsCard $variant={variant}>
      <Icon icon={icon} size="2.4rem" />
      <S.DetailsContent>
        {loading ? (
          <>
            <Skeleton width="10rem" height="2.4rem" />
            <Skeleton width="6rem" height="2.4rem" />
          </>
        ) : (
          <>
            <S.DetailsTitle>{title}</S.DetailsTitle>
            <S.DetailsValueRow>
              <S.DetailsValue>{value}</S.DetailsValue>
              {isFree && (
                <Badge color="green" size="small" variant="solid">
                  {t('visitor-parking:detailsCard.freeBadge')}
                </Badge>
              )}
            </S.DetailsValueRow>
          </>
        )}
      </S.DetailsContent>
    </S.DetailsCard>
  )
}
